<template>
  <wui-btn
    prepend-icon="closeRegularMdM"
    variant="neut"
    state="alpha"
    icon
    data-test="remove-quoted-message"
    @click.stop="onRemove"
  >
    <span class="sr-only select-none">{{ $t('chat.removeQuotedMessage') }}</span>
  </wui-btn>
</template>

<script setup lang="ts">
import { WuiBtn } from '@wui/common-library'

import { draftModel } from '@/entities/messages'

const props = defineProps<{
  pServed: string,
}>()

const emit = defineEmits<{
  (event: 'remove'): void
}>()

const { setDraftQuote } = draftModel.useDraftMessageStore()

const onRemove = () => {
  emit('remove')

  setDraftQuote(props.pServed)
}
</script>
